const {
    isSupportedCountry,
    parsePhoneNumberFromString
} = require("libphonenumber-js/max");
const countryCodes = require("../constants/countryCodes");
const {
    FORMAT_NATIONAL,
    FORMAT_INTERNATIONAL,
    FORMAT_RFC3966,
    REMOVE_PREFIX_PHONE_COUNTRIES
} = require("../constants/phoneNumber");

const getPhoneNumber = (value, countryCode) => {
    return parsePhoneNumberFromString(value, countryCode.toUpperCase()) || "";
};

const getPhoneByCountry = (phone, country) => {
    if (
        isSupportedCountry(country) &&
        Object.values(countryCodes).includes(country)
    ) {
        const phoneNumber = parsePhoneNumberFromString(phone, country);
        if (phoneNumber) {
            return phoneNumber;
        }
    } else {
        if (country) {
            throw new Error(`Phone library doesn't support ${country}`);
        } else {
            throw new Error("Country required");
        }
    }
};

const validPhone = (phone, country) => {
    const phoneNumber = getPhoneByCountry(phone, country);

    const validCountryCode =
        phoneNumber &&
        phoneNumber.metadata &&
        phoneNumber.metadata.country_calling_codes &&
        Array.isArray(
            phoneNumber.metadata.country_calling_codes[
            phoneNumber.countryCallingCode
            ]
        ) &&
        phoneNumber.metadata.country_calling_codes[
            phoneNumber.countryCallingCode
        ].includes(country);
    return validCountryCode && phoneNumber.isValid();
};

const formatPhone = (phone, country, format = FORMAT_NATIONAL) => {
    const phoneNumber = getPhoneByCountry(phone, country);

    if (
        [FORMAT_INTERNATIONAL, FORMAT_NATIONAL, FORMAT_RFC3966].includes(format)
    ) {
        return phoneNumber.format(format);
    } else {
        throw new Error(`Unsupported format ${format}`);
    }
};

const changePrefixPhoneFormat = value => {
    const firstDigit = value.substring(0, 1);
    if (firstDigit == "0") {
        return value.substring(1, value.length);
    }
    return value;
};

const getPhoneFormat = (value = "", originCountry) => {
    const phoneWithoutFormat = getPhoneNumber(value, originCountry);
    if (value && phoneWithoutFormat) {
        return phoneWithoutFormat.formatNational();
    }
    return value;
}

const updatePhoneFormatByCountry = (value, originCountry) => {
    return REMOVE_PREFIX_PHONE_COUNTRIES.includes(originCountry)
        ? changePrefixPhoneFormat(
            getPhoneFormat(value, originCountry)
        )
        : getPhoneFormat(value, originCountry);
};

module.exports = {
    validPhone,
    formatPhone,
    parsePhoneNumberFromString,
    getPhoneNumber,
    updatePhoneFormatByCountry
};
